import {Routes} from './routes';
import {Route, Navigate} from 'react-router-dom';
import {Sidebar} from './configs';
import {getState} from '../store';

export function toRoute<T extends keyof Routes>(route: T, params?: Routes[T]) {
  if (!params) {
    return route;
  }
  const searches: string[] = [];
  Object.entries(params).forEach(([k, val]) => {
    searches.push(k + '=' + JSON.stringify(val));
  });
  return route + '?' + searches.join('&');
}

export function MainRoute({children, ...rest}: any) {
  const token = getState().secure.token;

  return (
    <Route
      {...rest}
      exact
      render={({location}: any) =>
        token ? (
          location.pathname === '/' ? (
            <Navigate to="/jobs" state={{from: location}} />
          ) : (
            <>
              {Sidebar && <Sidebar />}
              <div className="main-content">{children}</div>
            </>
          )
        ) : (
          <Navigate to="/login" state={{from: location}} />
        )
      }
    />
  );
}

export function AuthRoute({children, ...rest}: any) {
  const token = getState().secure.token;

  return (
    <Route
      {...rest}
      exact
      render={({location}: any) =>
        token ? (
          <Navigate to="/jobs" state={{from: location}} />
        ) : location.pathname === '/verify-email' ? (
          <Navigate to="/login" state={{from: location}} />
        ) : (
          children
        )
      }
    />
  );
}
